import { Link } from 'react-router-dom';
import './Placeholder.css';

interface PlaceholderProps {
  title: string;
  /** One customer-facing sentence about what this section will offer. */
  description?: string;
}

/**
 * A section that is not open yet.
 *
 * This used to render a "Scaffold" eyebrow and a list of the engine endpoints the
 * screen would eventually call. That was a build note, and it was reachable on public
 * routes, meaning a ticket buyer landing on /artists saw internal API paths.
 *
 * Both are gone. The endpoints prop was removed outright rather than merely hidden,
 * because a hidden prop still ships those paths inside the JavaScript bundle. What is
 * left says only what a visitor needs: this part is not ready, here is the way back.
 */
export function Placeholder({ title, description }: PlaceholderProps) {
  return (
    <section className="placeholder">
      <h1 className="placeholder__title">{title}</h1>
      <p className="placeholder__description">
        {description ?? 'This section is not available yet.'}
      </p>
      <div className="placeholder__actions">
        <Link to="/events" className="button button--primary">
          Browse events
        </Link>
        <Link to="/" className="button button--ghost">
          Back to home
        </Link>
      </div>
    </section>
  );
}
